import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { SearchSupplierComponent } from './search-supplier.component';
import { ToastModule } from 'primeng';

const routes: Routes = [
  { path: '', component: SearchSupplierComponent, data: { title: 'Search Supplier' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SearchSupplierRoutingModule {}

@NgModule({
  imports: [
    SearchSupplierRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
  ],
  declarations: [SearchSupplierComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchSupplierModule {}
